'use client'

import { ThemeProvider as NextThemesProvider } from 'next-themes'
import type { ComponentProps } from 'react'

export function ThemeProvider({
  children,
  scriptProps,
  ...props
}: ComponentProps<typeof NextThemesProvider>) {
  return (
    <NextThemesProvider
      {...props}
      scriptProps={{
        ...scriptProps,
        // next-themes injects a FOUC-prevention <script>. React 19 flags
        // executable scripts rendered inside client components. Mark the
        // library script as a data block on both server and client so
        // hydration matches and remounts do not try to run it. The
        // executable bootstrap lives in the root layout instead.
        suppressHydrationWarning: true,
        type: 'application/json',
      }}
    >
      {children}
    </NextThemesProvider>
  )
}
